module.exports = __webpack_public_path__ + "static/img/icon1@2x.83ab5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon1@2x.png
// module id = 7zFj
// module chunks = 70